import { EMPTY_OBJECT } from '../../../constants/common'
import { isFolderFile, isImageFile, isPdfFile } from '../../../utils/file'
import { filterPermittedActionsWithDividers } from '../../../utils/massActions'
import {
  DOCUMENT_UPLOAD_DESTINATION_ALL,
  DOCUMENT_UPLOAD_DESTINATION_CURRENT,
  DOCUMENTS_ACTION_DUPLICATE_TO_RELATED,
  DOCUMENTS_ACTION_MARK_AS_INVOICE,
  DOCUMENTS_ACTION_MARK_AS_VULCAVO,
  getDocumentsItemActions,
} from '../../Document'
import { getRequestTitle } from '../../Request'

import {
  NO_RELATED_REQUESTS_TOOLTIP_KEY,
  REQUEST_PROFILE_TAB_DOCUMENTS_BREADCRUMB_REQUEST,
} from './RequestProfileTabDocuments.constants'

export function getRequestProfileTabDocumentsRootBreadcrumbs({ requestData }) {
  return [
    {
      id: REQUEST_PROFILE_TAB_DOCUMENTS_BREADCRUMB_REQUEST,
      title: getRequestTitle({
        requestNumber: requestData?.requestNumber,
        title: requestData?.title,
      }),
    },
  ]
}

export function getRequestProfileTabDocumentsUploadOptions({
  canAddFileToRelatedRequests,
  relatedRequestsCount,
  t,
}) {
  const hasNoRelatedRequests = relatedRequestsCount === 0

  const items = [
    {
      label: t('RequestProfileTabDocuments.UploadToCurrentRequestKey'),
      permission: true,
      value: DOCUMENT_UPLOAD_DESTINATION_CURRENT,
    },
    {
      disabled: hasNoRelatedRequests,
      label: t('RequestProfileTabDocuments.UploadToAllAttachedRequestsKey'),
      permission: canAddFileToRelatedRequests,
      tooltipContent: hasNoRelatedRequests
        ? t(NO_RELATED_REQUESTS_TOOLTIP_KEY)
        : undefined,
      value: DOCUMENT_UPLOAD_DESTINATION_ALL,
    },
  ]

  return filterPermittedActionsWithDividers(items)
}

export function getRequestProfileTabDocumentsItemActions({
  commonPermissions,
  contextData,
  item,
  user,
}) {
  const { permissions = EMPTY_OBJECT } = item

  const canAddFileToRelatedRequests =
    contextData?.requestData?.permissions?.can_add_file_to_related_requests
  const relatedRequestsCount = contextData?.relatedRequestsCount ?? 0
  const hasNoRelatedRequests = relatedRequestsCount === 0

  const showDuplicateToRelated =
    !isFolderFile(item) &&
    permissions.can_download &&
    canAddFileToRelatedRequests

  // The Request tab swaps the generic Duplicate + View report for
  // Mark as invoice + Duplicate to all attached requests.
  return getDocumentsItemActions({
    // Deleting is blocked (backend returns 403) unless the request allows it
    // (e.g. status is not OPENED, or a connected request).
    canDelete:
      contextData?.requestData?.permissions?.can_edit_rm_files !== false,
    canSendViaEmail: !contextData?.outboundUuid,
    commonPermissions,
    extraActions: [
      {
        label: 'DocumentMarkAsInvoice.ItemActionLabelKey',
        permission: isPdfFile(item) && permissions?.can_mark_as_invoice,
        value: DOCUMENTS_ACTION_MARK_AS_INVOICE,
      },
      {
        label: 'DocumentMarkAsVulcavo.ItemActionLabelKey',
        permission:
          (isPdfFile(item) || isImageFile(item)) &&
          permissions?.can_send_vulcavo_attachment &&
          !item?.is_sent_to_vulcavo,
        value: DOCUMENTS_ACTION_MARK_AS_VULCAVO,
      },
      {
        disabled: hasNoRelatedRequests,
        label: 'RequestProfileTabDocuments.DuplicateToRelatedActionKey',
        permission: showDuplicateToRelated,
        tooltipContent: hasNoRelatedRequests
          ? NO_RELATED_REQUESTS_TOOLTIP_KEY
          : undefined,
        value: DOCUMENTS_ACTION_DUPLICATE_TO_RELATED,
      },
    ],
    item,
    user,
  })
}
